export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10794.b7f35296.jpg";